
import { IServiceMap } from '@/business/BusinessFormData'
import { IFormMap } from '@/store/modules/formMap'
import { ICustomerAppKey, IOrganization } from '@/store/state'
import { IOrderForm } from '@/types/placeOrderTypes'
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import BasePage from '../BasePage.vue'
import BasicInfo from '../components/BasicInfo.vue'
import UploadMaterial from '../components/Upload/UploadMaterial.vue'
import XdocProjectPlan from '../components/XdocProjectPlan.vue'
import { getDefaultForm } from '../helper'

@Component({
  components: {
    BasePage,
    BasicInfo,
    UploadMaterial,
    XdocProjectPlan,
  },
})
export default class FbdToWordPage extends Vue {
  @Getter('order_id') order_id!: string
  @Getter('customerAppKey') customerAppKey!: ICustomerAppKey
  @Getter('organization') organization!: IOrganization
  @Getter('formMap')
  formMap!: IFormMap

  defaultForm: IOrderForm = {} as IOrderForm
  form: IOrderForm = {} as IOrderForm
  formInfo: null | IServiceMap = null
  regBookName = false

  type = ''
  name = ''
  reEdit = false

  BaseMounted(serviceType: string, name: string) {
    this.type = serviceType
    this.name = name
    this.formInfo = this.formMap.formMap![serviceType]
    this.defaultForm = getDefaultForm(serviceType, this.formInfo, this.organization, this.customerAppKey, name)
  }

  FormChange(form: IOrderForm) {
    this.form = form
  }

  creatCheckForm(form: IOrderForm) {
    if (!form.book_name) return this.$message.error('请输入图书名称')
    if (!form.alias) return this.$message.error('请输入工单别名')
    if (!form.subject) return this.$message.error('请选择学科')
    if (!form.stage) return this.$message.error('请选择学段')
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.book_name)) {
      this.regBookName = true
      return this.$message.error('图书名称含有非法字符')
    }
    if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(form.alias)) {
      return this.$message.error('工单别名含有非法字符')
    }
  }

  submitCheckForm(bounds: any, callback: (val: boolean) => void) {
    // 文件检查
    if (this.form.material.type === 0 && !this.form.material.oss_fbd_zips?.length)
      return this.$message.error('请上传zip文件')
    else if (this.form.material.type === 3 && !this.form.material.oss_pdf_files?.length) {
      this.$message.error('请上传pdf文件')
      return callback(true)
    }

    // 检查是否有制作内容
    if (!this.form.xdoc_planning?.length) {
      this.$message.error('请选择要制作的内容')
      return callback(true)
    }

    // 检查名称是否重复
    const names = this.form.xdoc_planning.map(item => item.name)
    if (Array.from(new Set(names)).length !== this.form.xdoc_planning.length) {
      this.$message.error('制作内容中有重名项目')
      return callback(true)
    }

    for (const plan of this.form.xdoc_planning) {
      // 检查名称是否包含非法字符
      if (!/^((?!\\|\/|:|\*|\?|"|<|>|\||').)*$/g.test(plan.name || '')) {
        this.$message.error('制作内容含有非法字符')
        return callback(true)
      }

      // 检查正文fbd文件
      if (!plan.origin_files!.filter(fbd => fbd.type === 1).length) {
        this.$message.error('制作内容中未选择正文fbd文件')
        return callback(true)
      }

      // 检查正文pdf文件（根据不同条件）
      const needCheckPdf = this.form.material.type !== 1
      if (needCheckPdf) {
        if (!plan.compare_pdf!.filter(pdf => pdf.type === 1).length) {
          this.$message.error('制作内容中未选择正文pdf文件')
          return callback(true)
        }
      }

      // 如果需要答案文件
      if (plan.config.fbd_type === 1) {
        // 检查答案fbd文件
        if (this.form.material.type !== 1) {
          if (!plan.origin_files!.filter(fbd => fbd.type === 0).length) {
            this.$message.error('制作内容中未选择答案fbd文件')
            return callback(true)
          }
        }

        // 检查答案pdf文件
        if (needCheckPdf) {
          if (!plan.compare_pdf!.filter(pdf => pdf.type === 0).length) {
            this.$message.error('制作内容中未选择答案pdf文件')
            return callback(true)
          }
        }
      }
    }

    return callback(false)
  }

  screenForm(form: any) {
    const keys = Object.keys(form)
    const defaultKeys = Object.keys(this.defaultForm)
    const screenkeys = keys.filter(item => defaultKeys.includes(item))
    const screenForm: any = {}
    screenkeys.forEach(item => {
      screenForm[item] = form[item]
    })
    return screenForm
  }
}
